/**
 * 대리 로그인 표시 — 대리 탭의 고객 영역에서는 **항상** 보인다 (260917-realm-sessions-impersonation).
 * 대리 종료는 서버에서 대리 세션 행만 끝낸다(쿠키를 건드리지 않는다). 운영자 탭은 그대로 남아 있다.
 */
import { auth } from '@geo-admin/shared/contract/api/index.ts';
import { call } from '../lib/call.ts';
import { forgetImpersonation } from '../lib/impersonation.ts';
import { Button } from './ui/button.tsx';

export async function endImpersonation(): Promise<void> {
  await call(auth.logout).catch(() => {});
  closeTab();
}

/** 대리 탭을 닫는다. 스크립트로 열린 탭이 아니면(탭 복원 등) 닫히지 않는다 — 그때만 운영자 화면으로 돌아간다 */
function closeTab(): void {
  forgetImpersonation();
  window.close();
  // close 는 바로 닫히지 않는다 — 곧바로 이동하면 닫기보다 이동이 먼저 시작될 수 있다
  setTimeout(() => window.location.replace('/admin'), 500);
}

export function ImpersonationBanner({ targetEmail, adminEmail }: { targetEmail: string; adminEmail: string }) {
  return (
    <div className="bg-amber-400 font-suit text-amber-950">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-3 gap-y-1 px-4 py-2 text-sm">
        <span className="rounded-full bg-amber-950 px-2 py-0.5 font-semibold text-[11px] text-amber-50">
          대리 로그인
        </span>
        <span className="min-w-0 break-all">
          <b>{targetEmail}</b> 계정으로 보고 있습니다 · 운영자 {adminEmail}
        </span>
        <Button
          size="sm"
          className="ml-auto bg-amber-950 text-white hover:bg-amber-900"
          onClick={() => void endImpersonation()}
        >
          대리 종료
        </Button>
      </div>
    </div>
  );
}

/** 대리 토큰이 끝났다 — 만료·운영자 로그아웃·대리 종료. 로그인 화면으로 보내지 않는다(다른 신원으로 이어진다) */
export function ImpersonationEnded() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4 font-suit">
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 text-center shadow-[0_20px_40px_-12px_#0a37611f] ring-1 ring-slate-200/70">
        <p className="font-bold text-lg">대리 로그인이 끝났습니다</p>
        <p className="mt-2 text-slate-600 text-sm">
          2시간이 지났거나, 운영자가 로그아웃했거나, 다른 곳에서 대리를 종료했습니다.
        </p>
        <Button variant="live" className="mt-5 w-full" onClick={closeTab}>
          탭 닫기
        </Button>
      </div>
    </div>
  );
}
